






































































































import { Vue } from 'vue-property-decorator'
import Vuex from 'vuex'
import VueHead from 'vue-head'
// eslint-disable-next-line import/no-named-default
import { default as lottie } from 'lottie-web'
import BrowserAlert from '@/components/home/BrowserAlert.vue'

Vue.use(Vuex)
Vue.use(VueHead)

interface State {
  slide: {
    left: number;
    isPulseAnimation: boolean;  // アイコンのちょっと大きくなるアニメーション
    animationStart: number; // fpsを間引く用
    stepCount: number;  // ステップ数
  };
  env: {
    // レスポンシブ対応のための変数
    deviceWidth: 'small' | 'medium';
    // サポートしていないブラウザか
    isNotSupportBrowser: boolean;
  };
}

export default Vue.extend({
  name: 'Home',

  head: {
    title: {
      inner: 'ミュージックメーカー',
      separator: '｜',
      complement: 'おだきゅうキッズ｜小田急電鉄',
    },
  },

  components: {
    'browser-alert': BrowserAlert,
  },

  data (): State {
    return {
      slide: {
        left: 0,
        isPulseAnimation: false,
        animationStart: 0,
        stepCount: 0,
      },
      env: {
        deviceWidth: 'small',
        isNotSupportBrowser: false,
      },
    }
  },

  mounted () {
    // 表示領域の管理
    const mediaQueryList = window.matchMedia('(max-width: 751px)')
    mediaQueryList.addListener(this.onChangeBreakPoint)
    this.detectDeviceByBreakPoint(mediaQueryList)

    // タイトルのlottieを表示
    const title = this.$el.querySelector('.js-title-logo')
    lottie.loadAnimation({
      container: title, // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'assets/lottie-data/title.json', // the path to the animation json
    })

    // スライドをスクロール
    this.startSlide()

    // IEは未サポートのブラウザ
    this.env.isNotSupportBrowser = navigator.userAgent.indexOf('Trident') >= 0 || Boolean(this.$route.query['browser-alert'])
  },

  methods: {
    /**
     * スライドを開始
     */
    startSlide () {
      window.requestAnimationFrame(this.slideStep)
    },

    /**
     * スライド処理
     * @param timestamp
     */
    slideStep (timestamp: number) {
      const progress = timestamp - this.slide.animationStart

      // requestAnimationFrameは間引く（スマホで実行すると端末がかなり熱くなる）
      if (progress > 33.3) {
        this.slide.animationStart = timestamp

        // 移動
        // アイコンが1ループするところで右に戻す（常に流れ続けるため）
        if (this.env.deviceWidth === 'small') {
          // 1ループ 810px
          if (this.slide.left > (-810 - -2)) {
            this.slide.left = this.slide.left - 2
          } else {
            this.slide.left = this.slide.left + (810 - 2)
          }
        } else {
          if (this.slide.left > (-1485 - -4)) {
            this.slide.left = this.slide.left - 4
          } else {
            this.slide.left = this.slide.left + (1485 - 4)
          }
        }

        this.slide.stepCount++

        // 一定カウントごとにパルスアニメーション
        if (this.slide.stepCount % 45 === 0) {
          // アニメーションする
          this.slide.isPulseAnimation = true
        } else if (this.slide.stepCount % 45 === 44) {
          // 次のアニメーションのためにクラスをクリア
          this.slide.isPulseAnimation = false
        }
      }

      window.requestAnimationFrame(this.slideStep)
    },

    /**
     * ブレイクポイントを通過した
     */
    onChangeBreakPoint (e: MediaQueryListEvent) {
      this.detectDeviceByBreakPoint(e)
    },

    /**
     * ブレイクポイントからデバイスを判別する
     * @param mq メディアクエリー or メディアクエリーイベント
     */
    detectDeviceByBreakPoint (mq: MediaQueryList | MediaQueryListEvent) {
      this.env.deviceWidth = mq.matches ? 'small' : 'medium'
    },
  },
})
